<div
  class="w-full rounded-full h-1"
  [ngClass]="[
    progressHeightClass ? progressHeightClass : '',
    progressBarGradientBackground ? 'progress-bar-gradient' : 'bg-grey'
  ]"
>
  <div class="progress" [ngStyle]="{ width: progressValue + '%' }"></div>
</div>
